module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard-section m-t-lg m-b-lg"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-job-request"
  }, [_vm._l((_vm.jobs), function(job) {
    return _c('job-request-item', {
      key: job.id,
      attrs: {
        "job": job
      }
    })
  }), _vm._v(" "), (_vm.haveNoJobRequests) ? _c('li', {
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("No job requests found.")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'jobs.requests'
      }
    }
  }, [_vm._v("View All")])], 1)]), _vm._v(" "), _c('job-request-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "far fa-question-circle"
  }), _vm._v(" Job Requests")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-51a1136d"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/JobRequestList.vue
// module id = 1000
// module chunks = 0